// eslint-disable-next-line import/prefer-default-export
import { moneysStingOptions } from '../constants/moneys';

export function focusNextElement(container) {
  // add all elements we want to include in our selection
  const focussableElements = 'a:not([disabled]):not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), [tabindex]:not([disabled]):not([tabindex="-1"])';
  if (document.activeElement) {
    const focussable = [...container.querySelectorAll(focussableElements)];
    //
    //   // check for visibility while always include the current activeElement
    //   (element) => element.offsetWidth > 0
    //     || element.offsetHeight > 0
    //     || element === document.activeElement,
    // );
    const index = focussable.indexOf(document.activeElement);
    if (index > -1) {
      const nextElement = focussable[index + 1] || focussable[0];
      nextElement.focus();
    }
  }
}

export function decimalToStr(value, defaultValue = '') {
  return value ? value.toLocaleString('uk', moneysStingOptions) : defaultValue;
}

export function convertStringToDate(stringDate) {
  const dateParts = stringDate.split(/[-T:.+]/g);
  const year = parseInt(dateParts[0], 10);
  const month = parseInt(dateParts[1], 10) - 1;
  const day = parseInt(dateParts[2], 10);
  const hour = parseInt(dateParts[3], 10);
  const minute = parseInt(dateParts[4], 10);
  const second = parseInt(dateParts[5], 10);
  const millisecond = parseInt(dateParts[6], 10);

  const date = new Date(
    Date.UTC(year, month, day, hour, minute, second, millisecond),
  );

  return date;
}
